<template>
  <div class="container">
    <el-page-header class="page-header" @back="goBack" content="新建渠道活码">
    </el-page-header>
    <!-- <div class="header">新建渠道活码</div> -->
    <div class="main">
      <el-form ref="ruleForm" :model="form" :rules="rules" label-width="12rem">
        <div class="form-header">
          <el-form-item label="渠道名称：" prop="name">
            <el-input clearable style="width: 47rem" placeholder="请输入名称" v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="自动验证：">
            <el-radio v-model="form.radio" label="1">是</el-radio>
            <el-radio v-model="form.radio" label="0">否</el-radio>
          </el-form-item>
          <el-form-item label="使用人员：" prop="names">
            <div class="person">
              <el-tag style="margin: 0 1.2rem 0 0"  effect="plain" v-for="item of form.names" :key="item">{{
                item }}</el-tag>
            </div>
            <el-button class="addBtn" icon="el-icon-plus" @click="onAdd">前往添加</el-button>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input clearable style="width: 47rem" placeholder="请输入备注" v-model="form.remark"></el-input>
          </el-form-item>
          <el-form-item label="客户标签：" prop="group_label">
            <div class="person">
              <el-tag v-for="item of arrth" style="margin: 0 1.2rem 0 0" effect="plain" :key="item">
                {{ item }}
              </el-tag>
            </div>
            <el-button class="addBtn" icon="el-icon-plus" @click="onTagDialog()">前往添加</el-button>
          </el-form-item>
        </div>
        <div class="form-footer">
          <el-form-item label-width="3rem">
            <el-button type="primary" @click="submitForm()">立即创建</el-button>
            <!-- <el-button style="margin-left:2rem;" @click="$router.back()">取消</el-button> -->
          </el-form-item>
        </div>
      </el-form>
    </div>
    <el-dialog center :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
    <el-dialog title="添加" center :visible.sync="onSubmitsc" width="25%">
      <!-- <el-checkbox-group v-model="checkList">
          <el-checkbox v-for="(item, index) in checkedCities" :key="index" :label="item">{{item.name}}</el-checkbox>
        </el-checkbox-group> -->
      <el-checkbox-group v-model="checkList">
        <el-checkbox v-for="(item, index) in checkedCities" :key="index" :label="item.userid">{{ item.name
        }}</el-checkbox>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmitsc = false">取 消</el-button>
        <el-button type="primary" @click="onSubmitsc = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="请选择标签" center :visible.sync="dialogTableVisible">
      <div v-for="item of tags" :key="item.group_id" class="tag-item">
        <el-checkbox v-model="item.checkAll" @change="handleCheckAllChange(item)">{{ item.group_name }}</el-checkbox>
        <div style="margin: 1.5rem 0"></div>
        <el-checkbox-group v-model="item.checkedCities" @change="handleCheckedCitiesChange(item)">
          <el-checkbox v-for="city in item.child" :label="city" :key="city.tag_id">{{ city.tag_name }}</el-checkbox>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <el-button type="primary" @click="offDialog">确 定</el-button>
      </span>
    </el-dialog>
    <right-people ref="dialog" :checkbox="checkbox" @handleSelect="handleSelect"></right-people>
  </div>
</template>
<script>
import axios from "axios";
import qs from "qs";
import rightPeople from '@/components/drawer/rightPeople';
export default {
  components: {
    rightPeople
  },
  data() {
    return {
      form: {
        name: "",
        scope: 1,
        remark: "",
        title: "",
        type: "无",
        url: "",
        link_url: "",
        describe: "",
        mini_name: "",
        mini_id: "",
        chat_id: "",
        media_id: "",
        radio: "1",
        value1: true,
        userid: "",
        user_list: [],
        group_label: "",
        names: []
      },
      rules: {
        mini_id: [
          { required: true, message: "请输入小程序ID", trigger: "blur" },
        ],
        name: [{ required: true, message: "请输入渠道名称", trigger: "blur" }],
        names: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个使用成员",
            trigger: "change",
          },
        ],
      },
      fileList: [],
      // 上传图片地址
      imageUrl: "",
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      accept: "",
      listType: "",
      tip: "",
      tooken: "",
      upParams: {},
      onSubmitsc: false,
      checkbox: false,
      checkedCities: [],
      checkList: [],
      module: "",
      selectionName: true,
      dialogTableVisible: false,
      tags: [],
      arrth: [],
      group_array: "",
    };
  },
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
      this.upParams.account_id = this.tooken.account_id;
    }
    if (!this.$route.query.id) {
      this.form.type = "无";
      return;
    }
    // this.getData();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getData() {
      this.axios
        .post(
          "/crm/Assistant/getWelcomeOne",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            id: this.$route.query.id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            const data = res.data.data;
            this.form.content = data.content;
            this.form.title = data.title;
            this.form.type = data.type;
            this.form.user_name = data.user_name;
            this.form.scope = data.scope;
            this.form.url = data.url;
            this.form.media_id = data.media_id;
            this.form.link_url = data.link_url;
            this.form.describe = data.describe;
            this.form.mini_name = data.mini_name;
            this.form.mini_id = data.mini_id;
            this.fileList.push({ url: data.url, name: data.file_name });
            this.setAccept();
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) { });
    },
    changeType() {
      this.form.title = "";
      this.form.user_name = "";
      this.form.url = "";
      this.form.media_id = "";
      this.form.link_url = "";
      this.form.describe = "";
      this.form.mini_name = "";
      this.form.mini_id = "";
      // this.chat_id = "";
      this.setAccept();
    },
    onAdd() {
      this.module = "getAddressBook";
      this.checkbox = true;
      this.isGroup = true;
      this.$refs.dialog.open();
    },
    setAccept() {
      switch (this.form.type) {
        case "图片":
          this.listType = "picture";
          this.tip = "只能上传JPG,PNG格式文件，且不超过2MB";
          this.accept = ".jpg,.png";
          break;
        case "图文":
          this.listType = "picture";
          this.tip = "只能上传JPG,PNG格式文件，且不超过2MB";
          this.accept = ".jpg,.png";
          break;
        case "小程序":
          this.listType = "picture";
          this.tip = "只能上传JPG,PNG格式文件，且不超过2MB";
          this.accept = ".jpg,.png";
          break;
        default:
          break;
      }
    },
    handleRemove(file, fileList) { },
    handlePreview(file) { },
    handleExceed(files, fileList) { },
    handleBeforeUpload(file) {
      const size = file.size / 1024 / 1024;
      if (this.form.type === "图片" || this.form.type === "链接") {
        if (size > 2) {
          this.$message({
            message: "上传图片文件过大",
            type: "error",
          });
          return false;
        }
      }
      if (this.form.type === "视频") {
        if (size > 10) {
          this.$message({
            message: "上传视频文件过大",
            type: "error",
          });
          return false;
        }
      }
      if (this.form.type === "文件") {
        if (size > 20) {
          this.$message({
            message: "上传文件过大",
            type: "error",
          });
          return false;
        }
      }
    },
    handleSuccess(response, file, fileList) {
      this.form.url = response.data.url;
      this.form.media_id = response.data.media_id;
      this.fileList.push(this.form.url);
      this.$message({
        message: response.msg,
        type: "success",
      });
    },
    beforeRemove(file, fileList) {
      this.form.url = [];
      this.fileList = [];
    },
    handleRemove(file) { },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) { },
    addContact() {
      this.axios
        .post(
          "/crm/ActiveCode/getUserList",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          console.log(res);
          this.checkedCities = res.data.data;
          for (var a = 0; a < this.checkedCities.length; a++) {
            for (var i = 0; i < this.checkList.length; i++) {
              if (this.checkedCities[a].userid == this.checkList[i].userid) {
                console.log(this.checkedCities);
                this.checkedCities[a].checked = true;
              }
            }
          }
        })
        .catch(function (err) { });
    },
    handleSelect(person) {
      switch (this.module) {
        case "getUserLists":
          this.form.userid = person.userid;
          this.checkList = person;
          break;
        default:
          break;
        case "getAddressBook":
          const userid = [];
          const user = [];
          person.map((item) => {
            userid.push(item.userid);
            user.push(item.name);
          });
          this.form.chat_id = userid.join();
          this.form.names = user;
          break;
      }
    },
    changeScope(label) {
      switch (label) {
        case "1":
          Reflect.deleteProperty(this.rules, "chat_id");
          break;
        default:
          this.rules.chat_id = [
            {
              required: true,
              message: "请选择成员",
              trigger: "blur",
            },
          ];
          break;
      }
    },
    submitForm() {
      if (this.form.name.trim() == "") {
        this.$message.error("渠道名称不能为空");
        return
      }
      const user = this.checkList.map((i) => i.userid);

      this.axios
        .post(
          "/crm/ActiveCode/addActiveCode",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            name: this.form.name,
            skip_verify: this.form.radio,
            group_label: this.group_array,
            user: this.form.chat_id,
            remark: this.form.remark,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.$router.push("/register/user/activeCode");
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) { });
    },
    submit() {
      const url = this.$route.query.id ? "editWelcome" : "addWelcome";
      this.axios
        .post(
          `/crm/Assistant/${url}`,
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            id: this.$route.query.id,
            scope: this.form.scope,
            type: this.form.type,
            content: this.form.content,
            title: this.form.title,
            url: this.form.url,
            link_url: this.form.link_url,
            link_title: this.form.linkTitle,
            describe: this.form.describe,
            mini_name: this.form.mini_name,
            mini_id: this.form.mini_id,
            chat_id: this.form.chat_id,
            media_id: this.form.media_id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success(res.data.msg);
            this.$router.go(-1);
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) { });
    },
    offDialog() {
      const arr = [];
      for (var a = 0; a < this.tags.length; a++) {
        for (var k = 0; k < this.tags[a].checkedCities.length; k++) {
          arr.push(this.tags[a].checkedCities[k].tag_name);
        }
      }
      this.form.group_label = arr.toString();
      this.arrth = arr;
      let group = this.tags.map((item) => {
        return {
          group_id: item.group_id,
          group_name: item.group_name,
          child: item.checkedCities,
        };
      });
      let group_label = group.filter((i) => {
        return i.child.length > 0;
      });
      this.group_array = JSON.stringify(group_label);
      this.dialogTableVisible = false;
    },
    onTagDialog() {
      this.dialogTableVisible = true;
      this.getLabelListUseAdmin();
    },
    getLabelListUseAdmin() {
      this.axios
        .post(
          "/crm/Assistant/getLabelListUseAdmin",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          let data = res.data.data;

          data.map((item) => {
            item.checkAll = false;
            item.checkedCities = [];
            item.isIndeterminate = true;
          });
          if (this.form.group_label) {
            // 回显选中数据
            this.from.group_label = JSON.parse(this.form.group_label);

            for (const d of data) {
              for (const g of this.form.group_label) {
                // 因为需要回显数据， 需要在全部数据内寻找与之对应的提交数据， 传递给全部数据中已选中字段checkedCities(已选中字段)
                if (d.group_id === g.group_id) {
                  // 由于全部数据checkedCities（已选中字段）只有与全部数据内的child相同才能回显选中效果，而提交后的child不行
                  // 因为提交的child对象虽然与全部数据对象内容一样，但两个对象是不相等的，它们并不是一个引用
                  // 对提交数据child与全部数据child比较，当相等时把全部数据的child相同条目传入checkedCities(已选中字段)
                  for (const c of g.child) {
                    for (const k of d.child) {
                      if (c.tag_id === k.tag_id) {
                        d.checkedCities.push(k);
                      }
                    }
                  }
                  let checkedCount = d.checkedCities.length;
                  d.checkAll = checkedCount === d.child.length;
                  d.isIndeterminate =
                    checkedCount > 0 && checkedCount < d.child.length;
                }
              }
            }
          }
          this.tags = data;
        })
        .catch(function (err) { });
    },
    handleCheckAllChange(val) {
      const findItem = this.tags.find((item) => {
        return item.group_id === val.group_id;
      });
      findItem.checkedCities = val.checkAll ? findItem.child : [];
      findItem.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      const findItem = this.tags.find((item) => {
        return item.group_id === value.group_id;
      });
      let checkedCount = value.checkedCities.length;
      findItem.checkAll = checkedCount === findItem.child.length;
      findItem.isIndeterminate =
        checkedCount > 0 && checkedCount < findItem.child.length;
    },
  },
};
</script>
<style scoped>
.header {
  line-height: 4rem;
  border-bottom: .1rem solid rgb(241, 239, 239);
}



.main {
  margin-top: 4rem;
}

.form-header,
.form-content {
  padding-top: 2.2rem;
  padding-right: 2.2rem;
  overflow: hidden;
}

.form-content,
.form-footer {
  margin-top: 2rem;
}

.el-upload-list__item-thumbnail {
  width: 10rem;
  height: 10rem;
}
.container{
  position: relative;
    top: -0.4rem;
}
.main{
    margin-top:0;
    background: #fff;
    padding: 2rem;
    border-radius:.8rem;

}
.el-form-item {
    margin-bottom: 4rem;
}
</style>